import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159\n        5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909\n        2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0\n        00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5\n        1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375\n        0 11-.75 0 .375.375 0 01.75 0z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "#6f7275",
    width: _ctx.width,
    height: _ctx.height
  }, _hoisted_3, 8, _hoisted_1))
}